var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeStudyButton',{attrs:{"setup":_vm.setup,"ach-tooltip":_vm.theoremTimeEstimate,"special-click":_vm.clickHandler()}},[_c('DescriptionDisplay',{attrs:{"config":_vm.study.config}}),(_vm.showRequirement)?[_c('br'),_c('span',[_vm._v(_vm._s(_vm.requirement))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }